type LogContext = Record<string, unknown>;

const LOG_PREFIX = '[prototype-spa]';

const withContext = (context?: LogContext) => (context ? [context] : []);

export const logger = {
  info(message: string, context?: LogContext) {
    if (import.meta.env.DEV) {
      console.info(LOG_PREFIX, message, ...withContext(context));
    }
  },
  warn(message: string, context?: LogContext) {
    console.warn(LOG_PREFIX, message, ...withContext(context));
  },
  error(message: string, error?: unknown, context?: LogContext) {
    console.error(LOG_PREFIX, message, error, ...withContext(context));
  },
};
